/* tslint:disable */
/* eslint-disable */
/**
 * CipherMail back-end API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CTLEntryStatus } from '../model';
// @ts-ignore
import type { CTLResult } from '../model';
/**
 * CTLApi - axios parameter creator
 * @export
 */
export const CTLApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} thumbprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cTLControllerDeleteCTL: async (thumbprint: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'thumbprint' is not null or undefined
            assertParamExists('cTLControllerDeleteCTL', 'thumbprint', thumbprint)
            const localVarPath = `/api/ctl/deleteCTL`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (thumbprint !== undefined) {
                localVarQueryParameter['thumbprint'] = thumbprint;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cTLControllerDeleteCTLs: async (requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('cTLControllerDeleteCTLs', 'requestBody', requestBody)
            const localVarPath = `/api/ctl/deleteCTLs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} thumbprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cTLControllerGetCTL: async (thumbprint: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'thumbprint' is not null or undefined
            assertParamExists('cTLControllerGetCTL', 'thumbprint', thumbprint)
            const localVarPath = `/api/ctl/getCTL`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (thumbprint !== undefined) {
                localVarQueryParameter['thumbprint'] = thumbprint;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cTLControllerGetCTLs: async (firstResult?: number, maxResults?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ctl/getCTLs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (firstResult !== undefined) {
                localVarQueryParameter['firstResult'] = firstResult;
            }

            if (maxResults !== undefined) {
                localVarQueryParameter['maxResults'] = maxResults;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cTLControllerGetCTLsCount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/ctl/getCTLsCount`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} thumbprint 
         * @param {CTLEntryStatus} status 
         * @param {boolean} allowExpired 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cTLControllerSetCTL: async (thumbprint: string, status: CTLEntryStatus, allowExpired: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'thumbprint' is not null or undefined
            assertParamExists('cTLControllerSetCTL', 'thumbprint', thumbprint)
            // verify required parameter 'status' is not null or undefined
            assertParamExists('cTLControllerSetCTL', 'status', status)
            // verify required parameter 'allowExpired' is not null or undefined
            assertParamExists('cTLControllerSetCTL', 'allowExpired', allowExpired)
            const localVarPath = `/api/ctl/setCTL`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (thumbprint !== undefined) {
                localVarQueryParameter['thumbprint'] = thumbprint;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (allowExpired !== undefined) {
                localVarQueryParameter['allowExpired'] = allowExpired;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CTLEntryStatus} status 
         * @param {boolean} allowExpired 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cTLControllerSetCTLs: async (status: CTLEntryStatus, allowExpired: boolean, requestBody: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'status' is not null or undefined
            assertParamExists('cTLControllerSetCTLs', 'status', status)
            // verify required parameter 'allowExpired' is not null or undefined
            assertParamExists('cTLControllerSetCTLs', 'allowExpired', allowExpired)
            // verify required parameter 'requestBody' is not null or undefined
            assertParamExists('cTLControllerSetCTLs', 'requestBody', requestBody)
            const localVarPath = `/api/ctl/setCTLs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication basicAuth required
            // http basic authentication required
            setBasicAuthToObject(localVarRequestOptions, configuration)

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (allowExpired !== undefined) {
                localVarQueryParameter['allowExpired'] = allowExpired;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(requestBody, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CTLApi - functional programming interface
 * @export
 */
export const CTLApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CTLApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} thumbprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cTLControllerDeleteCTL(thumbprint: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CTLResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cTLControllerDeleteCTL(thumbprint, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CTLApi.cTLControllerDeleteCTL']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cTLControllerDeleteCTLs(requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cTLControllerDeleteCTLs(requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CTLApi.cTLControllerDeleteCTLs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} thumbprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cTLControllerGetCTL(thumbprint: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CTLResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cTLControllerGetCTL(thumbprint, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CTLApi.cTLControllerGetCTL']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cTLControllerGetCTLs(firstResult?: number, maxResults?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CTLResult>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cTLControllerGetCTLs(firstResult, maxResults, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CTLApi.cTLControllerGetCTLs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cTLControllerGetCTLsCount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cTLControllerGetCTLsCount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CTLApi.cTLControllerGetCTLsCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} thumbprint 
         * @param {CTLEntryStatus} status 
         * @param {boolean} allowExpired 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cTLControllerSetCTL(thumbprint: string, status: CTLEntryStatus, allowExpired: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CTLResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cTLControllerSetCTL(thumbprint, status, allowExpired, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CTLApi.cTLControllerSetCTL']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {CTLEntryStatus} status 
         * @param {boolean} allowExpired 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cTLControllerSetCTLs(status: CTLEntryStatus, allowExpired: boolean, requestBody: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cTLControllerSetCTLs(status, allowExpired, requestBody, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CTLApi.cTLControllerSetCTLs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CTLApi - factory interface
 * @export
 */
export const CTLApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CTLApiFp(configuration)
    return {
        /**
         * 
         * @param {string} thumbprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cTLControllerDeleteCTL(thumbprint: string, options?: any): AxiosPromise<CTLResult> {
            return localVarFp.cTLControllerDeleteCTL(thumbprint, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cTLControllerDeleteCTLs(requestBody: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.cTLControllerDeleteCTLs(requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} thumbprint 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cTLControllerGetCTL(thumbprint: string, options?: any): AxiosPromise<CTLResult> {
            return localVarFp.cTLControllerGetCTL(thumbprint, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} [firstResult] 
         * @param {number} [maxResults] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cTLControllerGetCTLs(firstResult?: number, maxResults?: number, options?: any): AxiosPromise<Array<CTLResult>> {
            return localVarFp.cTLControllerGetCTLs(firstResult, maxResults, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cTLControllerGetCTLsCount(options?: any): AxiosPromise<number> {
            return localVarFp.cTLControllerGetCTLsCount(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} thumbprint 
         * @param {CTLEntryStatus} status 
         * @param {boolean} allowExpired 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cTLControllerSetCTL(thumbprint: string, status: CTLEntryStatus, allowExpired: boolean, options?: any): AxiosPromise<CTLResult> {
            return localVarFp.cTLControllerSetCTL(thumbprint, status, allowExpired, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {CTLEntryStatus} status 
         * @param {boolean} allowExpired 
         * @param {Array<string>} requestBody 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cTLControllerSetCTLs(status: CTLEntryStatus, allowExpired: boolean, requestBody: Array<string>, options?: any): AxiosPromise<void> {
            return localVarFp.cTLControllerSetCTLs(status, allowExpired, requestBody, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CTLApi - object-oriented interface
 * @export
 * @class CTLApi
 * @extends {BaseAPI}
 */
export class CTLApi extends BaseAPI {
    /**
     * 
     * @param {string} thumbprint 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CTLApi
     */
    public cTLControllerDeleteCTL(thumbprint: string, options?: RawAxiosRequestConfig) {
        return CTLApiFp(this.configuration).cTLControllerDeleteCTL(thumbprint, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CTLApi
     */
    public cTLControllerDeleteCTLs(requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return CTLApiFp(this.configuration).cTLControllerDeleteCTLs(requestBody, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} thumbprint 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CTLApi
     */
    public cTLControllerGetCTL(thumbprint: string, options?: RawAxiosRequestConfig) {
        return CTLApiFp(this.configuration).cTLControllerGetCTL(thumbprint, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} [firstResult] 
     * @param {number} [maxResults] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CTLApi
     */
    public cTLControllerGetCTLs(firstResult?: number, maxResults?: number, options?: RawAxiosRequestConfig) {
        return CTLApiFp(this.configuration).cTLControllerGetCTLs(firstResult, maxResults, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CTLApi
     */
    public cTLControllerGetCTLsCount(options?: RawAxiosRequestConfig) {
        return CTLApiFp(this.configuration).cTLControllerGetCTLsCount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} thumbprint 
     * @param {CTLEntryStatus} status 
     * @param {boolean} allowExpired 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CTLApi
     */
    public cTLControllerSetCTL(thumbprint: string, status: CTLEntryStatus, allowExpired: boolean, options?: RawAxiosRequestConfig) {
        return CTLApiFp(this.configuration).cTLControllerSetCTL(thumbprint, status, allowExpired, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {CTLEntryStatus} status 
     * @param {boolean} allowExpired 
     * @param {Array<string>} requestBody 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CTLApi
     */
    public cTLControllerSetCTLs(status: CTLEntryStatus, allowExpired: boolean, requestBody: Array<string>, options?: RawAxiosRequestConfig) {
        return CTLApiFp(this.configuration).cTLControllerSetCTLs(status, allowExpired, requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}

